/* Size the cart drawer to the VISIBLE viewport so in-app browsers (WhatsApp,
   Instagram, etc.) that mis-report dvh still keep the pinned footer + checkout
   button on screen instead of running taller than the visible area. The dialog's
   CSS height:100dvh stays the fallback; this refines it only where the
   VisualViewport API is available, and clears itself when the drawer closes. */
(function () {
  var vv = window.visualViewport;
  if (!vv) return;

  var dialog = document.querySelector('#cart-drawer .theme-drawer__dialog');
  if (!dialog) return;

  var lastH = '', lastT = '', raf = 0;
  function sync() {
    if (dialog.hasAttribute('open')) {
      var h = Math.round(vv.height) + 'px';
      var t = Math.round(vv.offsetTop) + 'px';
      if (h !== lastH) { dialog.style.height = h; lastH = h; }
      if (t !== lastT) { dialog.style.top = t; lastT = t; }
      // iOS Safari does not always fire a VisualViewport resize when its
      // toolbars collapse/expand mid-scroll, so re-read every frame while the
      // drawer is open (writes only on change — cheap).
      if (!raf) raf = requestAnimationFrame(tick);
    } else {
      dialog.style.height = '';
      dialog.style.top = '';
      lastH = lastT = '';
      if (raf) { cancelAnimationFrame(raf); raf = 0; }
    }
  }
  function tick() { raf = 0; sync(); }

  vv.addEventListener('resize', sync);
  vv.addEventListener('scroll', sync);
  window.addEventListener('resize', sync);
  window.addEventListener('scroll', sync, { passive: true });
  // The <theme-drawer> is data-skip-node-update, so the dialog persists across
  // section morphs and this observer stays valid for the page's lifetime.
  new MutationObserver(sync).observe(dialog, { attributes: true, attributeFilter: ['open'] });
  sync();
})();
